module.exports = __webpack_public_path__ + "img/logo.272e90a.svg";